module.exports = __webpack_public_path__ + "img/bulletin-board-m.5ab9b4a1.svg";